import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center" data-id="element-181">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-182">
          Si sos docente de Música en primaria o secundaria,
          <br data-id="element-183" />
          <span className="text-[#FFD700]" data-id="element-184">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-185">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-186">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-187">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-188">
              Domingo a la noche buscando material que nunca queda bien
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-189">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-190">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-191">
              Clases improvisadas porque no tenés guion ni estructura
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-192">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-193">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-194">
              Actos a las corridas sin ensayo real ni propuesta clara
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-195">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-196">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-197">
              Evaluaciones inventadas porque no tenés criterios listos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-198">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-199">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-200">
              Horas perdidas que nunca recuperás
            </p>
          </div>
        </div>

        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-8" data-id="element-201">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Gold divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FFD700] to-transparent w-full" data-id="element-202" />
      </div>
    </section>;
}